import styled from "styled-components";

export default styled.div`
  display: flex;
  align-items: center;

  // background should be if index 0 #FF5C4D, if 1 #65C9BD, if 2 #09100F
  background: ${(props) =>
    props.index === 1
      ? "#FF5C4D"
      : props.index === 2
      ? "#65C9BD"
      : props.index === 3
      ? "#09100F"
      : "#B5C0C4"};

  color: ${(props) => (props.index === 3 ? "#F9F8F5" : "#2f3139")};

  padding: 1.5rem 0.8rem 1.5rem;
  font-size: 1rem;
  font-weight: light;
  width: ${(props) => `calc(${props.index * 25}% + 1rem)`};
  // border-radius: 0.4rem;
  border-radius: 5px;

  & > div {
    vertical-align: baseline;
    top: -0.4rem;
  }

  & > span {
    margin-left: auto;
    font-size: 1.2rem;
  }

  @media (min-width: 550px) {
    font-size: 1.3rem;
    padding: 1.5rem 2rem 1.5rem;

    & > span {
      margin-left: auto;
      font-size: 1.7rem;
    }
  }
`;
